module.exports = __webpack_public_path__ + "images/file_icons_v2/woff-e43aadae3f8992a758daee67e60672c9.svg";